import BaseService from '@/services/base.service';
import store from '../store'

const API_URL = process.env.VUE_APP_API_URL;
// const CURRENCY_CODE = process.env.VUE_APP_CURRENCY_CODE;
// const ACCOUNT_SLUG = process.env.VUE_APP_ACCOUNT_SLUG;

class TokenService extends BaseService {
    apiGetToken(customerID, partnerCode) {
        return this.post(API_URL + '/api/v2/token', {
            account: store.state.account,
            currency: store.state.currencyCode,
            customerID: customerID,
            partner_code: partnerCode
        }).then((response) => {
            const status = response.data.status;
            if (status === 'success') {
                return response.data.customer_token;
            }
            return response.data;
        }).catch(err => {
            throw err.response.data;
        })
    }
}

export default new TokenService();
